<app-card label="Terms of Use">

    <div class="header">
      <p>The patient whose information you are trying to access has not accepted the Terms of Use Agreement yet. Until the Terms of Use have been accepted you will not be able to access this information.</p>
      <p><dx-button text="Back to My Account" (onClick)="backToMyAccount()"></dx-button></p>
    </div> 

</app-card>
<router-outlet></router-outlet>